import React from 'react';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

import Flags from './flags.json';
import FlagsImage from './flags.png';

countries.registerLocale(enLocale);

export interface FlagIconProps {
  code: string | null;
}

export const FlagIcon: React.FC<FlagIconProps> = ({ code }) => {
  if (!code || typeof code !== 'string') {
    return null;
  }

  const flag = Flags[code.toUpperCase() as keyof typeof Flags];
  if (!flag) {
    return null;
  }

  const [w, h, x, y] = flag;
  const countryName = countries.getName(code, 'en') || code;

  return (
    <div
      style={{
        backgroundImage: `url(${FlagsImage})`,
        backgroundPosition: `${-x}px ${-y}px`,
        backgroundSize: '224px 199px',
        display: 'inline-block',
        height: `${h}px`,
        marginRight: '6px',
        width: `${w}px`,
      }}
      title={countryName}
    />
  );
};
